/** The quick set the reaction picker opens on. */
export const QUICK_REACTIONS = ['👍', '👀', '✅', '🙏', '🎉', '❤️', '❌'];

/** How many reactor names a chip tooltip lists before collapsing the rest into "N others". */
export const MAX_LISTED_REACTORS = 3;

export const TEAM_ONLY_REACTIONS_NOTICE = 'Only your team sees reactions';

/** How long a touch is held before it counts as a long press. */
export const REACTION_LONG_PRESS_MS = 400;

/** A press that drifts this far is a scroll, not a long press. */
export const REACTION_LONG_PRESS_MOVE_TOLERANCE_PX = 12;
